import { useSupabase } from "@/components/contexts/DatabaseSyncWrapper";
import { updateCanvasStoryboards } from "@/store/supabaseSlice";
import { useDispatch } from "react-redux";

const useUpdateStoryboardSize = (canvas: any) => {
  const { supabaseClient } = useSupabase();
  const dipsatch = useDispatch();

  const setSize = async (
    storyboard: any,
    width: number | null,
    height: number | null
  ) => {
    if (!supabaseClient) {
      console.error("Supabase client not available");
      return;
    }

    const newStoryboards = canvas.storyboards.map((s: any) => {
      if (s.id === storyboard.id) {
        const changes = {
          width: width || s.width,
          height: height || s.height,
        };

        return { ...s, ...changes };
      } else {
        return s;
      }
    });

    updateCanvasStoryboards(supabaseClient, dipsatch, newStoryboards, canvas);
  };

  return { setSize };
};

export default useUpdateStoryboardSize;
